module.exports = __webpack_public_path__ + "img/img_cs_img4.0f8624f7.png";